(() => {
  let stickyInstance = null;

  const initStarterSimpleSticky = () => {
    if (typeof window.Sticky !== 'function') return;

    if (stickyInstance && typeof stickyInstance.destroy === 'function') {
      stickyInstance.destroy();
    }

    stickyInstance = new window.Sticky('.starter-simple__media[data-starter-simple-sticky]');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStarterSimpleSticky);
  } else {
    initStarterSimpleSticky();
  }

  document.addEventListener('shopify:section:load', initStarterSimpleSticky);
  window.addEventListener('resize', () => {
    if (stickyInstance && typeof stickyInstance.update === 'function') {
      stickyInstance.update();
    }
  });
})();
